/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    success : null,
    storeAISummaryLogs: null
};


const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.generateSummaryActions.REQUEST_GENERATE_SUMMARY_DATA:
      return {
        ...state,
    };
    case actions.generateSummaryActions.GENERATE_SUMMARY_DATA_RECEIVED:
   
          return{
      ...state,
      success: action.success
    };
    case actions.generateSummaryActions.REQUEST_AI_LOGS:
      return {
        ...state,
    };
    case actions.generateSummaryActions.AI_LOGS_RECEIVED:
   
    return{
        ...state,
        storeAISummaryLogs: action.success
};
    default:
      return state;
  }
};

export default reducer;
